import { IGridLayout } from 'types'
import { LayoutHelpers } from '../../../desktopTypes'
import { addLayoutTag } from '../../../utils/helpers'
import { parsePadding, useLayoutItems } from '../../../utils/layoutUtils'
import { SGrid } from '../../scaled'
import EmptyLayout from '../EmptyLayout'
import Layout from '../Layout'

export default function GridLayout({
  columnCount = 2,
  playVideo,
  layouts,
  gap = 8,
  keyPath,
  itemHeight,
  style,
  title,
}: Omit<IGridLayout, 'type'> & LayoutHelpers) {
  const items = useLayoutItems(
    layouts.map(l => ({ ...l, style: { grow: 1, height: itemHeight } })),
    keyPath
  )

  if (items.length === 0) return <EmptyLayout type="grid" />

  const padding = parsePadding({ style, title })

  return (
    <SGrid {...padding} flex={1} gap={gap} columns={columnCount} {...addLayoutTag('grid')}>
      {items.map(({ key, ...rest }, i) => (
        <Layout playVideo={playVideo} style={{ grow: 1 }} key={i} {...rest} />
      ))}
    </SGrid>
  )
}
